import { DEFAULT_POINT_TYPE } from './types'

export const FORM_CREATE_POINTS_DEFAULT = {
  type: DEFAULT_POINT_TYPE,
  target_time_arrival: null,
  target_time_departure: null,
  service_time: 'PT15M',
  activity_label: null,
  note: '',
  address: null,
}